import { TFunction } from 'i18next';

export const metaData = (t: TFunction) => ({
  'big-spenders': {
    title: t('analytics.segments.bigSpenders.title'),
    image: '/img/analytics/big-spenders.png',
    emptyState: {
      image: '/img/analytics/big-spenders-empty.png',
      title: t('analytics.segments.bigSpenders.emptyTitle'),
      description: t('analytics.segments.bigSpenders.emptyDescription')
    },
    alt: t('analytics.segments.bigSpenders.title'),
    tooltip: t('analytics.segments.bigSpenders.tooltip'),
    link: '/big-spenders',
    valueType: 'currency',
    bounceBlastDescription: t('analytics.segments.bigSpenders.bounceBlastDescription')
  },
  'the-regulars': {
    title: t('analytics.segments.theRegulars.title'),
    image: '/img/analytics/the-regulars.png',
    emptyState: {
      image: '/img/analytics/the-regulars-empty.png',
      title: t('analytics.segments.theRegulars.emptyTitle'),
      description: t('analytics.segments.theRegulars.emptyDescription')
    },
    alt: t('analytics.segments.theRegulars.title'),
    tooltip: t('analytics.segments.theRegulars.tooltip'),
    link: '/the-regulars',
    valueType: 'events',
    bounceBlastDescription: t('analytics.segments.theRegulars.bounceBlastDescription')
  },
  'hot-streaks': {
    title: t('analytics.segments.hotStreaks.title'),
    image: '/img/analytics/hot-streaks.png',
    emptyState: {
      image: '/img/analytics/hot-streaks-empty.png',
      title: t('analytics.segments.hotStreaks.emptyTitle'),
      description: t('analytics.segments.hotStreaks.emptyDescription')
    },
    alt: t('analytics.segments.hotStreaks.title'),
    tooltip: t('analytics.segments.hotStreaks.tooltip'),
    link: '/hot-streaks',
    valueType: 'months',
    bounceBlastDescription: t('analytics.segments.hotStreaks.bounceBlastDescription')
  },
  'cold-streaks': {
    title: t('analytics.segments.coldStreaks.title'),
    image: '/img/analytics/cold-streaks.png',
    emptyState: {
      image: '/img/analytics/cold-streaks-empty.png',
      title: t('analytics.segments.coldStreaks.emptyTitle'),
      description: t('analytics.segments.coldStreaks.emptyDescription')
    },
    alt: t('analytics.segments.coldStreaks.title'),
    tooltip: t('analytics.segments.coldStreaks.tooltip'),
    link: '/cold-streaks',
    valueType: 'months',
    bounceBlastDescription: t('analytics.segments.coldStreaks.bounceBlastDescription')
  },
  'new-customers': {
    title: t('analytics.segments.newCustomers.title'),
    image: '/img/analytics/new-customers.png',
    emptyState: {
      image: '/img/analytics/new-customers-empty.png',
      title: t('analytics.segments.newCustomers.emptyTitle'),
      description: t('analytics.segments.newCustomers.emptyDescription')
    },
    alt: t('analytics.segments.newCustomers.title'),
    tooltip: t('analytics.segments.newCustomers.tooltip'),
    link: '/new-customers',
    valueType: 'none',
    bounceBlastDescription: t('analytics.segments.newCustomers.bounceBlastDescription')
  }
});
